export default "__VITE_ASSET__CyQaBK$H__"